import { GraphQLClient } from 'graphql-request';
import config from '../Config/Environment';
import { clearToken, getToken } from '../Utils/Token';

const AUTH_ERROR_CODES = new Set(['UNAUTHORIZED', 'USER_NOT_FOUND']);

const buildClient = () => {
  const token = getToken();
  if (!token) return new GraphQLClient(`${config.endpoint}/`);
  return new GraphQLClient(`${config.endpoint}/`, {
    headers: { authorization: `Bearer ${token}` },
  });
};

/**
 * Normalize a graphql-request `ClientError` into a stable shape consumers can
 * branch on. Backend now surfaces auth/permission failures through the
 * standard `errors[].extensions.code` channel (UNAUTHORIZED, USER_NOT_FOUND,
 * FORBIDDEN); auth failures also clear the local token so PrivateRoute can
 * bounce the user to login.
 */
const normalizeError = e => {
  const first = e?.response?.errors?.[0];
  const errorCode = first?.extensions?.code ?? null;
  const errorMessage = first?.message ?? e?.message ?? 'GraphQL request failed';

  if (errorCode && AUTH_ERROR_CODES.has(errorCode)) {
    clearToken();
  }

  return { error: true, errorCode, errorMessage };
};

const graphql = async (name, properties, type = 'query', params = null) => {
  const graphQLClient = buildClient();

  const query = params
    ? `
      ${type} {
        ${name}(${Object.entries(params)
          .map(([key, value]) => `${key}:"${value}"`)
          .join()}) {
          ${properties}
        }
      }
    `
    : `
      ${type} {
        ${name} {
          ${properties}
        }
      }
    `;

  return graphQLClient.request(query).catch(normalizeError);
};

export default graphql;
